<script setup lang="ts">
import type { NavigationItem } from 'comark-content'

const { headerLinks } = useHeaderLinks()

const mobileNavigation = computed<NavigationItem[]>(() => {
  return [
    ...headerLinks.value.map(link => ({
      ...link,
      title: link.label,
      path: link.to,
      icon: link.children?.length ? undefined : link.icon,
      children: link.children?.map(child => ({
        ...child,
        title: child.label,
        path: child.to
      }))
    } as NavigationItem)),
    {
      title: 'Design Kit',
      icon: 'i-lucide-palette',
      path: '/design-kit'
    }
  ].filter((item): item is NavigationItem => Boolean(item))
})
</script>

<template>
  <UContentNavigation
    :navigation="mobileNavigation"
    :collapsible="false"
    variant="link"
    highlight
    :ui="{
      trigger: 'font-medium data-[state=open]:text-toned tracking-wide text-[11px] uppercase',
      link: 'data-[state=open]:text-muted',
      linkLeadingIcon: 'group-data-[state=open]:text-muted'
    }"
  />
</template>
